const types = Object.freeze({
  ConServicio: 2,
  ConServicioPendiente: 4,
});
export default types;
